
<template>
  <div>
    <div
      class="d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"
    >
      <div>
        <router-link :to="{ path: '/races'}">
          <button type="submit" class="btn btn-warning text-white active btn-sm px-3 mr-3">Yarışlar</button>
        </router-link>
        <router-link :to="{ path: '/seasons'}">
          <button type="submit" class="btn btn-info btn-sm px-3 mr-3">Sezonlar</button>
        </router-link>

        <router-link :to="{ path: '/members'}">
          <button type="submit" class="btn btn-danger btn-sm px-3 mr-3">Üyeler</button>
        </router-link>
      </div>
      <span></span>
    </div>
    <card>
      <div v-if="!err">

      <table class="table table-hover table-striped table-bordered mb-0 race-table">
        <caption>Toplam: {{total}}</caption>
        <thead class="thead-dark">
          <th>Ad Soyad</th>
          <th>Kulüp Adı</th>
          <th>E-Mail</th>
          <th>Telefon Numarası</th>
          <th>Başvuru Tarihi</th>
          <th>Durum</th>
          <!-- <th>URL</th>
        <th>Kategori</th>
          <th>Sezon</th>-->
          <th style="width:15%">İşlemler</th>
        </thead>
        <tbody>
          <tr v-for="item in table" :key="item.id">
            <td>{{item.full_name}}</td>
            <td>{{item.club_name}}</td>
            <td>{{item.email}}</td>
            <td>{{item.phone}}</td>
            <td>{{item.created | moment("Do/MM/YYYY HH:mm:ss")}}</td>
            <td>{{item.vStatus}}</td>
            <!-- <td>{{item.url}}</td>
          <td>{{item.category.name}}</td>
            <td>{{item.sub_category.name}}</td>-->
            <td>
              <router-link
                :to="{ path: '/race-applications/inspect/'+item.id}"
                v-b-tooltip
                title="İncele"
                class="btn btn-primary btn-fill btn-xs"
                tag="li"
              >
                <i class="fas fa-edit"></i>
              </router-link>
              <router-link
                :to="{ path: '/race-applications/edit/'+item.id}"
                v-b-tooltip
                title="Revize Talep Et "
                class="btn btn-warning btn-fill btn-xs"
                tag="li"
              >
                <i class="fas fa-exchange-alt"></i>
              </router-link>
              <!-- <a href="#" class="btn btn-xs btn-success btn-fill" v-b-tooltip title="Önizleme"><i class="fas fa-eye"></i> {{item.view_count}}</a> -->
              <a
                href="javascript:void(0)"
                class="btn btn-xs btn-danger btn-fill"
                v-if="item.status !== 4 "
                v-on:click="changeStatus(item.id,4)"
                v-b-tooltip
                title="Reddet"
                id="deactivate-item.id"
              >
                <i class="fas fa-eye-slash"></i>
              </a>
              <a
                href="javascript:void(0)"
                class="btn btn-xs btn-success btn-fill"
                v-if="item.status !== 1"
                v-b-tooltip
                v-on:click="changeStatus(item.id,1)"
                title="Kabul Et"
                id="activate-item.id"
              >
                <i class="fas fa-eye"></i>
              </a>
              <!-- <a href="#" class="btn btn-xs btn-dark btn-fill" v-b-tooltip  title="Yorumlar"><i class="far fa-comment-alt"></i> {{item.commentCount}}</a> -->
            </td>
          </tr>
        </tbody>
      </table>
      <nav aria-label="Page navigation small">
        <ul class="pagination justify-content-end">
          <li class="page-item" v-bind:class="{disabled: isFirst()}">
            <a class="page-link" v-on:click="getRaces(page - 1,type)">Öncesi</a>
          </li>
          <li
            class="page-item"
            v-for="current in pageCount"
            v-if="isInScope(current)"
            v-bind:class="{active: isActive(current), 'mr-2': current == 1, 'ml-2': current == pageCount.length}"
            :key="current"
          >
            <a
              href="javascript:void(0)"
              class="page-link active"
              v-on:click="getRaces(current,type)"
            >{{current}}</a>
          </li>
          <li class="page-item" v-bind:class="{disabled: isLast()}">
            <a class="page-link" v-on:click="getRaces(page + 1,type)">Sonrası</a>
          </li>
        </ul>
      </nav>
      </div>
      <div v-if="err">
          {{err}}
      </div>
    </card>
  </div>
</template>
<script>
import Card from "src/components/UIComponents/Cards/Card.vue";

export default {
  data: function() {
    return {
      id: this.$route.params.id,
      race: {
        status: 1
      },
      table: null,
      total: 0,
      limit: localStorage.getItem("filterLimit"),
      page: 1,
      pageCount: null,
      navigation: true,
      post_id: null,
      viewCounts: [],
      err:null
    };
  },
  components: {
    Card
  },

  methods: {
    changeStatus: function(id, status) {
      this.toggleLoader();
      this.race.status = status;
      this.$http.post("/api/race/edit/" + id, this.race).then(
        response => {
           this.$http
            .post("/api/race/send-mail/" + id+'/'+status, this.race)
            .then(response => {

            }, e => {
              
            });
          if (status == 1) {
            this.notifier("top", "right", "success", "Talep Kabul Edildi");
          } else if(status==4) {
            this.notifier("top", "right", "warning", "Talep Reddedildi");
          }

          this.getRaces(this.page, this.type);
          this.toggleLoader();
        },
        e => {
                     this.toggleLoader();
                                                                                                          if(!e.body.Error){
              this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            }else{
              this.notifier('top', 'right', 'danger', e.body.Error)

            }
        }
      );
    },
    isInScope: function(c) {
      if (c === 1) {
        return true;
      }
      if (c === this.pageCount.length) {
        return true;
      }
      if (c - this.page > 3 || this.page - c > 3) {
        return false;
      }
      return true;
    },
    isActive: function(v) {
      return v === this.page;
    },
    isFirst: function() {
      return this.page === 1;
    },
    isLast: function() {
      return this.page === Math.ceil(this.total / this.limit);
    },
    getRaces: function(p = 1) {
      this.toggleLoader();
      var url =
        "/api/filter/race/post_id/" +
        this.id +
        "/limit/" +
        this.limit +
        "/page/" +
        p;
      this.$http.get(url).then(
        response => {
          this.table = response.body.data;
          this.total = response.body.meta.total;
          this.page = p
          this.pageCount = [];
          for (var i = 0; i < this.total / this.limit; i++) {
            this.pageCount.push(i + 1);
          }
          this.toggleLoader();
        },
        er => {
                    this.toggleLoader();

if(!er.body.Error){
             this.notifier(
              'top',
              'right',
              'danger',
              'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
              )
            }else{
              this.err = er.body.Error;
            this.notifier(
              'top',
              'right',
              'danger',
              er.body.Error
              )
            }
        }
      );
    },
    toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewRacePanel(event) {
      event.stopPropagation();
      if (document.getElementById("new-post").classList.contains("d-none")) {
        document.getElementById("new-post").classList.remove("d-none");
      } else {
        document.getElementById("new-post").classList.add("d-none");
      }
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.getRaces();
    });
  }
};
</script>
<style>
.race-table thead th {
    font-size: 16px!important;
}
.race-table tbody tr td {
    font-size: 15px!important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/RaceModules/Index.vue